import React, { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { InputWithLabel } from "../../components/micro";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { otpverify } from "../../redux/auth/slice";

const OtpVerify = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const email = location?.state?.email;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className={`h-screen overflow-hidden relative`}>
      <div className="flex items-center justify-center h-full bg-no-repeat bg-cover bg-center opacity-95 bg-gradient-to-r from-[rgba(255,235,79,0.5)] to-[rgba(69,160,85,0.5)]">
        <section className="w-full">
          <div className="max-w-lg w-full mx-auto rounded-lg drop-shadow-lg bg-[#FFFFFFE5] px-8 py-12">
            <div className="px-4">
              <div className="my-8 text-center">
                <h1 className="sm:text-2xl text-2xl font-ebGaramond font-normal mb-1">
                  Verify OTP
                </h1>
                <p className="text-base text-default_black mb-1 font-normal">
                  Please enter the OTP sent to your registered email:
                  <span className="font-semibold"> {email}</span>
                </p>
              </div>

              <Formik
                initialValues={{
                  otp: "",
                }}
                validationSchema={Yup.object({
                  otp: Yup.string()
                    .matches(/^\d{4,6}$/, "OTP must be 4–6 digits")
                    .required("Please enter the OTP"),
                })}
                onSubmit={(values) => {
                  setLoading(true);

                  const payload = {
                    ...values,
                    email: email,
                  };

                  dispatch(otpverify(payload)).then((res) => {
                    setLoading(false);
                    if (res.type === "otpverify/fulfilled") {
                      navigate("/new-password");
                    }
                  });
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="space-y-5">
                      {/* OTP Field */}
                      <InputWithLabel
                        className={
                          errors.otp && touched.otp
                            ? `border border-red`
                            : `border`
                        }
                        idFromName="otp"
                        label="Enter OTP*"
                        type="text"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.otp}
                        errors={errors.otp && touched.otp}
                        errorsText={errors.otp}
                        maxLength={6}
                      />

                      <button
                        type="submit"
                        className="w-full block text-white bg-themeBtn text-center text-base uppercase rounded transition duration-500 py-2 lg:px-7 px-4"
                      >
                        {loading ? "Verifying..." : "VERIFY OTP"}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default OtpVerify;
